import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Rocket, Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

const SYM = { USD: "$", BRL: "R$", AUD: "A$" };
let cache = null;

export const PromoteButtons = ({ listing, label = "Promote this listing", compact = false }) => {
  const [prices, setPrices] = useState(cache);
  const [busy, setBusy] = useState(null);
  useEffect(() => { if (!cache) api.get("/promo-prices").then(({ data }) => { cache = data.prices; setPrices(cache); }).catch(() => {}); }, []);
  const cur = (listing.currency || "AUD").toUpperCase();
  const table = prices?.[cur] || prices?.AUD || {};

  const promote = async (pkg) => {
    setBusy(pkg);
    try {
      const { data } = await api.post("/payments/checkout", { listing_id: listing.listing_id, package: pkg, currency: cur, origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Could not start checkout"); setBusy(null); }
  };

  return (
    <div data-testid={`promote-buttons-${listing.listing_id}`} className={compact ? "flex flex-wrap items-center gap-1.5" : "flex flex-wrap items-center gap-2"}>
      {!compact && <span className="inline-flex items-center gap-1 text-xs font-bold uppercase tracking-widest text-[#FF3B30]"><Rocket size={13} /> {label}</span>}
      {["7", "15", "30"].map((pkg) => (
        <button key={pkg} data-testid={`promote-${pkg}-${listing.listing_id}`} disabled={!!busy} onClick={() => promote(pkg)}
          className="inline-flex items-center gap-1 rounded-full bg-[#FF3B30] px-3 py-1.5 text-xs font-bold text-white transition-colors hover:bg-[#E6352B] disabled:opacity-60">
          {busy === pkg ? <Loader2 size={12} className="animate-spin" /> : <Rocket size={12} />}
          {pkg}d{table[pkg] != null ? ` · ${SYM[cur] || cur + " "}${table[pkg].toFixed(2)}` : ""}
        </button>
      ))}
    </div>
  );
};
